<template>
  <div id="members" class="module">
    <h1>Innovator Award Winners</h1>

    <el-row :gutter="28">
      <el-col
        v-for="(innovatorAward, index) in InnovatorAward"
        :key="index"
        :span="12"
      >
        <div class="award-block flexbox flexbox__v-center">
          <div class="aside">
            <span>{{ innovatorAward.year }}</span>
          </div>

          <div class="clip-shadow">
            <img
              :src="innovatorAward.image"
              class="clip-circle"
              width="125px"
              height="125px"
            />
          </div>

          <div class="content">
            <p class="title">{{ innovatorAward.title }}</p>
            <p class="text">{{ innovatorAward.award }}</p>
            <a :href="innovatorAward.link">Read more</a>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ApolloInnovatorAwards from "@/graphql/Company/InnovatorAwards.gql";

export default {
  name: "AwardWinners",
  apollo: {
    InnovatorAward: {
      query: ApolloInnovatorAwards
    }
  }
};
</script>

<style lang="scss" scoped>
.award-block {
  height: 195px;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 1.75rem;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.aside {
  flex: 0 0 16px;
  min-width: 0;
  height: 100%;
  margin-right: 1.375rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.375rem 0;
  border-right: 1px solid #d8d8d8;

  font-weight: 500;
  font-size: 22px;
  color: rgba(91, 91, 91, 0.61);
  letter-spacing: 1px;
  text-align: center;
  line-height: 29px;
}

.aside > span {
  transform: rotate(-90deg);
}

.content {
  flex: 1;
  margin: 0 2.25rem 0;

  .title {
    font-weight: 700;
    font-size: 16px;
    color: #2bd8b6;
    letter-spacing: 0;
    line-height: 23px;
  }

  .text {
    font-weight: 500;
    font-size: 16px;
    color: #8a8a8a;
    letter-spacing: 0;
    line-height: 23px;
  }
}

.clip-shadow {
  filter: drop-shadow(0px 2px 21px rgba(0, 0, 0, 0.19));
}

.clip-circle {
  clip-path: circle(62.5px at center);
}
</style>
